import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import router from './router'

import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.config.productionTip = false

Vue.use(VueGlide);
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_SITEKEY,
  loaderOptions: {
    autoHideBadge: true
  }
});

// global class
import "@/assets/global.css"

import store from './store'

import './assets/tailwind.css'

new Vue({
  router,
  store,
  VueReCaptcha,
  render: h => h(App)
}).$mount('#app')
